import { Component, OnInit, ViewChild, ElementRef, NgZone, EventEmitter, Output, HostListener, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import {DomSanitizer} from "@angular/platform-browser";

import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import {SessionService} from '../../Services/session.service';
import { HttpHeaders } from '@angular/common/http';
import { CementingStatusService } from '../../Services/cementing-status.service';
import { CementingDifficulty } from '../../models/cementing-status';
declare var angularComponentRef:any;
@Component({
  selector: 'app-activity-details',
  templateUrl: './activity-details.component.html',
  styleUrls: ['./activity-details.component.css']
})

export class ActivityDetailsComponent implements OnInit, OnDestroy {

  @Output() getActivityType:EventEmitter<any> = new EventEmitter();
  /** Cementing quiz questions on screen (true from quiz-started until quiz-ended or cancel). */
  @Output() cementingQuizActive: EventEmitter<boolean> = new EventEmitter();

  constructor(private router:Router, private sessionService: SessionService, private route: ActivatedRoute, private httpClientService: HttpClientService, private domSanitizer: DomSanitizer, private _ngZone: NgZone, private cementingStatusService: CementingStatusService) {
  window['angularComponentRef'] = {component: this, zone: _ngZone};

  }
  sub: any;
  courseName: String;
  pageName: String;
  pageChanged: String;
  activityId: String;
  activityState: String = "play";
  activityData: any;
  activityLink: any = this.domSanitizer.bypassSecurityTrustResourceUrl("");
  activityType: String;
  corelationID:string;
  froumType:string;
  showImage:boolean = false;
  warningMsg:boolean = false;
  archived:boolean = false;
  archivedMessage:any='';
  userRole:string='student';
  trackingDone:boolean=false;
  activityImageURL:string = AppSettings.cdnUrl + "assets/images/activity_img_play.png";
  journeyCourseId;
  /** Set when the player hosts a Scholaranium cementing quiz instead of a course activity. */
  cementingSection: string = null;
  cementingSubject: string = null;
  cementingDifficulty: CementingDifficulty = null;
  routerSubscription;
  @ViewChild('iframe', { static: false }) iframe: ElementRef;
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
      console.log("leaving nowwwwwww");
      this.trackTime();
      return true;
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {

      if(params['page'] && params['activity'])
      {
      this.pageName = params['page'];
      console.log("My params are activity and page name");
      this.activityId = params['activity'];
      this.getData();
      window.scrollTo(0,0);
      }
      else if (params['page'] && params['section'] && params['quizId'])
      {
        this.pageName = params['page'];
        this.cementingSection = params['section'];
        this.loadCementingReview(params['quizId']);
        window.scrollTo(0,0);
      }
      else if (params['page'] && params['subject'] && params['difficulty'])
      {
        this.pageName = params['page'];
        this.cementingSection = params['section'];
        this.cementingSubject = params['subject'];
        this.cementingDifficulty = params['difficulty'];
        this.loadCementingQuiz();
        window.scrollTo(0,0);
      }
      else if (params['corelationid'])
      {
          console.log("In review mode");
          this.corelationID = params['corelationid'];
          this.getReviewModeData();
      }
      this.trackingDone = false;
    });
    this.sessionService.updateActivityState$
     .subscribe(item => {console.log("acitivity paused"); if(item != 0) {this.pauseActivity();}}
   );
   this.sessionService.sharedUserRole.subscribe((data)=>{
     if(data)
     {
       console.log(data);
       this.userRole = data;
     }
   });
   this.routerSubscription = this.router.events.subscribe((event)=>{
     if(event instanceof NavigationStart)
     {
       this.trackTime();
     }
   });
  }

async trackTime()
{
  console.log(this.activityType);
  // Cementing quizzes are not course activities: nothing to abandon.
  if(!this.trackingDone && this.activityId)
  {
    await this.httpClientService.getSync(AppSettings.restApiUrl + '/api/activity/'+this.activityId+'/abandon',new HttpHeaders()).then((this.successCallback,this.failureCallback));
  }
  this.trackingDone=true;
}
successCallback(result)
{
}
failureCallback(error)
{
}
changeForumsData()
{
  console.log ("test passed");
  this.pageChanged="page is changed"+Math.floor(Date.now() / 1000).toString();
  this.sessionService.updateForumsData(1);
}

buttonClick()
{
  console.log("button clicked");
  let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;

var pause = doc.getElementsByClassName("cs-button btn-unstyled force-unstyled inflexible")[0];
console.log(pause);
pause.click();
}
pauseActivity()
{
    console.log("button clicked");
    let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
    if(doc == null)
    {
      var iframeElem = (<HTMLIFrameElement>document.getElementById("activity-iframe"));
      doc = iframeElem.contentDocument || iframeElem.contentWindow;
    }
    var pauseIcon = doc.getElementsByClassName("pause-icon")[0];
    if(pauseIcon != undefined)
    {
       var pauseBtn = pauseIcon.parentElement;
       pauseBtn.click();
    }
}
  iframeLoad() {
  this.pageChanged="iframe loaded";
  var self=this;
    if (this.activityType == "HTML5") {
      var activityId = this.activityId;
      var restApiUrl = AppSettings.restApiUrl;
      let doc = this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
      let win=this.iframe.nativeElement.contentWindow;
      console.log(win);
      (function(open) {

          win.XMLHttpRequest.prototype.open = function(method, url, async, user, pass) {
            console.log(method);
      	if(url.indexOf("statements?statement") >0) {
             		this.withCredentials= true;
                console.log("statements called ");
                //self.pageChanged="page is changed";
                angularComponentRef.zone.run(() => {angularComponentRef.component.changeForumsData();})
      	}
        else if(url.indexOf("activities/state?stateId") >0)
        {
            this.withCredentials= true;
        }
              open.call(this, method, url, async, user, pass);
          };

      })(win.XMLHttpRequest.prototype.open);


    var element = doc.getElementsByClassName("pause-icon")[0];// grab a reference to your element
      /*console.log("printing ");
      console.log(this.iframe.nativeElement.contentWindow);
      var player= this.iframe.nativeElement.contentWindow.GetPlayer();
      console.log("player object");
      console.log(player);
      */
      doc.addEventListener('click', function(event) {

        var a = event.target;
        while (a.nodeType === 1 && typeof (a) !== "undefined") {
          var buttonIdentifier = "cs-button btn-unstyled force-unstyled inflexible";
          /*if (a.hasAttribute("class") && a.getAttribute("class") && (a.getAttribute("class").indexOf("play-icon") >= 0 || a.getAttribute("class").indexOf("pause-icon") >= 0)) {
            isStateButton = true;
          }*/
          var play = doc.getElementsByClassName("play-icon")[0];
          var pause = doc.getElementsByClassName("pause-icon")[0];
          if (a.hasAttribute("class") && a.getAttribute("class") && a.getAttribute("class").indexOf(buttonIdentifier) >= 0 && (a.contains(play) || a.contains(pause))) {
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
              if (this.readyState == 4 && this.status == 200) {
                console.log(this.responseText);
                console.log("toggled");
              }
            };
            xhttp.open("PUT", restApiUrl + "/api/toggle/" + activityId+'/?timestamp='+Math.floor(Date.now() / 1000), true);
            xhttp.withCredentials = true;
            xhttp.send();
            break;
          }
          a = a.parentNode;
        }
      });
    }
  }

  getData() {
//  this is a comment for a cache testing
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + '/api/activity/' + this.activityId + '/page/' + this.pageName, headers)
        .subscribe(
        (data) => {
          this.journeyCourseId = data.courseJourneyId;
          this.activityLink = this.domSanitizer.bypassSecurityTrustResourceUrl(data.activityLink);
          this.activityType = data.activityType;
          this.archived = data.archived;
          this.archivedMessage = this.domSanitizer.bypassSecurityTrustHtml(data.archivedMessage);
          this.sessionService.shareForumType(data.forumType);
          this.getActivityType.emit(this.activityType);
          this.sessionService.updateJourneyCourseId(this.journeyCourseId);
        }

        );
  }

  getReviewModeData()
  {
    let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/link/forum/' + this.corelationID + '/', headers)
      .subscribe(
      (data) => {
        this.activityLink = this.domSanitizer.bypassSecurityTrustResourceUrl(data.activityUrl);
        this.showImage = true;
        this.archived = data.archived;
        this.archivedMessage = this.domSanitizer.bypassSecurityTrustHtml(data.archivedMessage);
        this.froumType = data.forumType;
        this.sessionService.shareForumType(data.forumType);

        this.activityId = data.forumObjectId;
        this.pageName = data.pageName;
        if(this.froumType == "SLIDE")
        {
            this.warningMsg = true;
        }
      }

      );
  }
  playActivity()
  {
     this.showImage = false;
     if(location.href.indexOf('journey') > -1) {
      this.router.navigate(["/journey", 'page', this.pageName, "activity", this.activityId]);
     } else {
      this.router.navigate(["/page", this.pageName, "activity", this.activityId]);
     }
  }

  /**
   * Scholaranium cementing quiz in the player iframe (embedded mode): the next
   * quiz of the stage, which the backend picks from subject and difficulty.
   * Scholaranium asks for Standard / Relaxed timing itself and reports its
   * lifecycle by postMessage; the course listing Back link is the way out.
   */
  loadCementingQuiz()
  {
    this.activityType = 'CEMENTING';
    this.announceCementing(false);
    // A reattempt (or a quiz named by its template) carries the template correlation id as a query parameter.
    const query = this.route.snapshot.queryParamMap;
    const url = this.cementingStatusService.quizLaunchUrl(this.cementingSection, this.cementingSubject, this.cementingDifficulty, {
      templateCorrelationId: query.get('template'),
      retake: query.get('retake') === '1'
    });
    this.activityLink = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  /** Result / review of a finished cementing quiz in the player iframe (embedded mode). */
  loadCementingReview(quizId: number)
  {
    this.activityType = 'CEMENTING';
    this.announceCementing(false);
    const url = this.cementingStatusService.reviewUrl(this.cementingSection, quizId);
    this.activityLink = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  /**
   * Tells the host body the player frames a cementing page. Deferred a tick: the
   * route params arrive during init, and the host has already checked its sidebar
   * bindings by then (ExpressionChangedAfterItHasBeenChecked otherwise).
   */
  private announceCementing(quizActive: boolean)
  {
    setTimeout(() => {
      this.getActivityType.emit(this.activityType);
      this.cementingQuizActive.emit(quizActive);
    });
  }

  @HostListener('window:message', ['$event'])
  onScholaraniumMessage(event: MessageEvent)
  {
    const data = event && event.data;
    // Only while the player frames Scholaranium (quiz or review); the subject is known for a quiz only.
    if (this.activityType !== 'CEMENTING' || !data || data.source !== 'scholaranium') { return; }
    if (data.event === 'cementing-quiz-ended' || data.event === 'cementing-quiz-started') {
      // The stage changed: the listing must fetch the status again when the student goes back.
      if (this.cementingSubject) { this.cementingStatusService.refresh(this.cementingSubject); }
      this.cementingQuizActive.emit(data.event === 'cementing-quiz-started');
    }
    else if (data.event === 'cementing-cancelled' || data.event === 'cementing-back-to-course') {
      // Cancel on the timing popup, or "Back to course" on the result page.
      this.cementingQuizActive.emit(false);
      this.backToCoursePage();
    }
  }

  backToCoursePage()
  {
    if(location.href.indexOf('journey') > -1) {
      this.router.navigate(["/journey", 'page', this.pageName]);
    } else {
      this.router.navigate(["/page", this.pageName]);
    }
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    if (this.cementingSubject) { this.cementingStatusService.refresh(this.cementingSubject); }
  }
}
